<mat-toolbar>
    <mat-toolbar-row class="justify-content-between">
        <button mat-icon-button (click)="toggleSidebar()">
            <mat-icon>menu</mat-icon>
        </button>
        <div class="row mr-2 ml-auto">
            <ul>
                <li>
                    <button mat-button [matMenuTriggerFor]="menu" class="user mt-2 d-flex align-items-center">
                        <img src="../../../assets/images/1.png" class="user-image mr-1 p-2" />
                        {{this.firstName | titlecase}}
                        <mat-icon class="user-image-icon ml-1">keyboard_arrow_down</mat-icon>
                    </button>

                    <mat-menu #menu="matMenu">
                        <img src="../../../assets/images/1.png" alt=" " class="user-image mr-1 p-2"
                            style="margin-left: 15px;" />{{this.firstName | titlecase}} {{this.lastName | titlecase | slice:0:5 }}{{this.lastName?.length > 5 ? '...' : ''}}
                        <mat-divider></mat-divider>
                        <button mat-menu-item [routerLink]="['/All/myProfile']">
                            <mat-icon>person</mat-icon>My Profile
                        </button>
                        <mat-divider></mat-divider>
                        <button mat-menu-item [routerLink]="['/All/changePassword']">
                            <mat-icon class="nav-icon">password</mat-icon>Change Password
                        </button>
                        <mat-divider></mat-divider>
                        <button mat-menu-item routerLink="/mainDashboard" (click)="clear()">
                            <mat-icon>exit_to_app </mat-icon>Logout
                        </button>
                    </mat-menu>
                </li>
            </ul>
        </div>
    </mat-toolbar-row>
</mat-toolbar>